import { z } from '@hono/zod-openapi'
import { benefitRecentTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertBenefitRecent = z.infer<typeof zInsertBenefitRecent>
export type SelectBenefitRecent = z.infer<typeof zSelectBenefitRecent>
export type UpdateBenefitRecent = z.infer<typeof zUpdateBenefitRecent>
export type QueryBenefitRecent = z.infer<typeof zQueryBenefitRecent>
export type TrackBenefitRecent = z.infer<typeof zTrackBenefitRecent>
export type BenefitRecentResponseItem = z.infer<
    typeof zBenefitRecentResponseItem
>
export type ColumnsOfBenefitRecentTable =
    keyof typeof benefitRecentTable._.columns

export const zSelectBenefitRecent = createSelectSchema(benefitRecentTable)

export const zInsertBenefitRecent = createInsertSchema(benefitRecentTable).omit(
    {
        id: true,
        createdAt: true,
        updatedAt: true,
    },
)

export const zUpdateBenefitRecent = zInsertBenefitRecent.partial()

export const zQueryBenefitRecent = zInsertBenefitRecent
    .extend({
        id: z.string(),
        ids: z.string().array(),
        limit: z.coerce.number().optional(),
    })
    .extend(zCommonQuery.shape)
    .partial()

export const zTrackBenefitRecent = z.object({
    benefitId: z.string(),
    userId: z.string().optional(),
    clientId: z.string().optional(),
    sessionId: z.string().optional(),
    interactionType: z.string().optional().default('view'),
})

export const zBenefitRecentStats = z.object({
    activeDeals: z.string(),
    partnerBrands: z.string(),
    categories: z.string(),
    totalSavings: z.string(),
})

export const zBenefitRecentResponseItem = zSelectBenefitRecent.extend({
    title: z.string().optional(),
    description: z.string().nullable().optional(),
    discount: z.string().nullable().optional(),
    originalPrice: z.number().nullable().optional(),
    salePrice: z.number().nullable().optional(),
    badge: z.string().nullable().optional(),
    badgeColor: z.string().nullable().optional(),
    image: z.string().optional(),
    brandLogo: z.string().nullable().optional(),
    category: z.string().nullable().optional(),
})
